import { Component, OnInit, Input, EventEmitter, Output, ElementRef, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WidgetComponent implements OnInit {
  @Input()
  label: string;

  @Input()
  public get open() {
    return this._open;
  }
  public set open(value) {
    this._open = value;
  }
  private _open = false;

  @Input()
  showActionsOnHover = false;

  @Input()
  canToggle = true;

  @Input()
  isCompact = false;

  @Output()
  opened: EventEmitter<boolean> = new EventEmitter<boolean>();


  constructor(
    private element: ElementRef
  ) { }

  ngOnInit() {
  }

  handleClickHeader() {
    if (!this.canToggle) {
      return;
    }

    this.toggleWidget();

    // Only emit opened event when triggered by user. We do this so the application can react
    // specifically to user input, without interference from programatic changes of the opened
    // state.
    this.opened.emit(this.open);
  }

  toggleWidget() {
    if (!this.canToggle) {
      return;
    }

    this.open = !this.open;
  }
}
